const menuEndpoints = {
    getMenuCategory: "/menu/getMenuCategory",
    getMenuItems: "/menu/getMenuItems",
  };
  
export default menuEndpoints;